export function formatNumber(value, decimals = 2) {
  const n = Number(value) || 0;
  try {
    return n.toLocaleString('es-AR', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  } catch (e) {
    // fallback
    return n.toFixed(decimals);
  }
}
